import React from "react";
import Card from "../../components/_add_new_card/Card/Card";
import leftArrow from "../../assets/leftArrow.svg";
import Layout from "../../shared/Layout/Layout";
import styles from "./AddNewCard.module.scss";

const AddNewCard = () => {
  return (
    <Layout>
      <div className={styles.container}>
        <div className={styles.subContainer}>
          <div className={styles.leftArrow}>
            <img src={leftArrow} alt="go-back" />
          </div>
          <h1>Add New Card</h1>
          <Card />
        </div>
      </div>
    </Layout>
  );
};

export default AddNewCard;
